import Vue from "vue";
import Router from "vue-router";
import store from "./store/store";
import demoHelper from "@/assets/js/demoHelper.js";
import i18n from "./i18n";

Vue.use(Router);

function lazyView(view) {
  return () => import(/* webpackChunkName: "lazy-view-[request]" */ `${view}`);
}
export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      // component: () => import('./views/Home.vue'),
      component: lazyView("./views/Home.vue"),
      beforeEnter: (to, from, next) => {
        // demoHelper.handleDemoGuideStatus()
        Promise.all([store.dispatch("getTemplates"), store.dispatch("getContentTypes")]).then(() => {
          store.dispatch("setCategoryFilter").then(() => {
            next();
          });
        });
      }
    },
    {
      path: "/templates/:templateId?",
      name: "template",
      // component: () => import('./views/Editor.vue'),
      component: lazyView("./views/Editor.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.templates.length == 0) {
          store.dispatch("getTemplates").then(() => {
            next();
          });
        } else next();
      }
    },

    {
      path: "/data",
      name: "data",
      // component: () => import('./views/DataArea.vue'),
      component: lazyView("./views/DataArea.vue"),
      beforeEnter: (to, from, next) => {
        Promise.all([
          store.dispatch("getContentTypes"),
          store.dispatch("getContentSources"),
          store.dispatch("getContentSources2")
        ]).then(() => {
          store.dispatch("getIntegrationSettings").then(() => {
            next();
          });
        });
      }
    },

    {
      path: "/settings",
      name: "settings", 
      component: lazyView("./views/Settings.vue"),
    },
    {
      path: "/login",
      name: "login",
      component: lazyView("./views/Login.vue"),
      // component: Login
      beforeEnter: (to, from, next) => {
        next();
      }
    },
    {
      path: "/signup",
      name: "signup",
      component: lazyView("./views/SignupFlow.vue"),
      beforeEnter: (to, from, next) => {
        const setLocale = (locale) => {
          localStorage.setItem("language-storage", locale);
          i18n.locale = locale;
        };

        const params = to.query;
        if (params.language) {
          switch (params.language) {
            case "da":
              setLocale("da");
              break;
            case "en":
              setLocale("en");
              break;
            default:
              setLocale("en");
          }
        }
        next();
      }
      // component: SignUp
    },
    {
      path: "/reset-password",
      name: "reset-password",
      component: lazyView("./views/ResetPassword.vue")
      // component: ResetPassword
    },
    {
      path: "/forgot-password",
      name: "forgot-password",
      component: lazyView("./views/ForgotPassword.vue")
      // component: ForgotPassword
    },
    { path: "*", redirect: "/" },

    {
      path: "/demo/:demokey?",
      name: "demo",
      // component: () => import('./views/Editor.vue'),
      component: lazyView("./views/Editor.vue"),
      beforeEnter: (to, from, next) => {
        if (
          process.env.NODE_ENV != "development" &&
          !window.location.origin.toLowerCase().includes("demo") &&
          to.name.includes("demo")
        ) {
          store.commit("resetDemoState");
          return next(from || "/");
        }
        i18n.locale = "da";
        store.commit("setDummyTemplate");
        store.commit("startDemoVersion");
        next();
      },
      children: [
        {
          path: "signup",
          name: "demo.signup",
          beforeEnter: (to, from, next) => {
            if (
              from &&
              from.params &&
              from.params.demokey &&
              store.state.demoData &&
              from.params.demokey == store.state.demoData.metadata.demoKey
            ) {
              // Prevent going back to signup route from demo route
              next(false);
              store.state.loadingRoute = false;
            } else {
              store.commit("setDummyTemplate");
              store.commit("startDemoVersion");
              next();
            }
          }
        }
      ]
    }
  ]
});
